import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    phrases: Array,
    interval: { type: Number, default: 3000 },
    duration: { type: Number, default: 500 }
  }

  connect() {
    this.currentIndex = 0

    // Set initial styles for transition
    this.element.style.transition = `opacity ${this.durationValue}ms ease-in-out, transform ${this.durationValue}ms ease-in-out`
    this.element.style.opacity = '1'

    // Start the rotation
    this.startRotation()
  }

  disconnect() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval)
    }
  }

  startRotation() {
    this.rotationInterval = setInterval(() => {
      this.rotateText()
    }, this.intervalValue)
  }

  rotateText() {
    const nextIndex = (this.currentIndex + 1) % this.phrasesValue.length

    // Fade out current text
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateY(20px)'

    // After fade out, change text and fade in
    setTimeout(() => {
      this.element.textContent = this.phrasesValue[nextIndex]
      this.element.style.opacity = '1'
      this.element.style.transform = 'translateY(0)'
      this.currentIndex = nextIndex
    }, this.durationValue)
  }
}
